'use client'

import Footer from '@/components/footer'
import NavBar from '@/components/nav-bar'
import { Link } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

type Props = {
  error: Error
  reset(): void
}

export default function Error({ error, reset }: Props) {
  const t = useTranslations('app.ErrorPage')

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <>
      <NavBar />
      <main className='flex flex-1 flex-col items-center p-5 sm:p-10'>
        <div className='hero bg-primary container mt-10 rounded'>
          <div className='hero-content text-center'>
            <div className='max-w-3xl'>
              <h1>{t('title')}</h1>
              <p className='pt-1 pb-5'>{t('description')}</p>
              <div className='flex justify-center gap-3'>
                <Link
                  className='btn'
                  href={'/'}
                  aria-label={t('action.return.aria-label')}
                >
                  {t('action.return.title')}
                </Link>
                <button
                  className='btn'
                  onClick={reset}
                  aria-label={t('action.reset.aria-label')}
                >
                  {t('action.reset.title')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}
